import { combineReducers } from 'redux';
import userReducer from 'reducers/user';
import textInfosReducer from 'reducers/textInfos';
import locationReducer from './location';


export const makeRootReducer = asyncReducers => (
  combineReducers({
    location: locationReducer,
    user: userReducer,
    textInfos: textInfosReducer,
    ...asyncReducers,
  })
);

export const injectReducer = (store, { key, reducer }) => {
  const storeReducer = store;
  if (Object.hasOwnProperty.call(storeReducer.asyncReducers, key)) {
    return;
  }

  storeReducer.asyncReducers[key] = reducer;
  storeReducer.replaceReducer(makeRootReducer(storeReducer.asyncReducers));
};

export default makeRootReducer;



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/store/reducers.js